export default "__VITE_ASSET__4SQQKtex__"